// @kds/header-tab-scroll-view 不支持一码多投，在web端使用ScrollView代替
import { ScrollView, View } from 'react-native';

export const NestedScrollView = ScrollView;
export const CollapsibleHeaderTabView = View;
export const HPageViewHoc = () => View;

export default View;
